import { Box, Flex, TextInput, Tooltip, Text } from "@mantine/core";
import {
  MantineReactTable,
  MRT_ColumnDef,
  MRT_RowSelectionState,
  useMantineReactTable,
} from "mantine-react-table";
import React, { useEffect, useState } from "react";
import { _localization } from "../../../../../../config/location";
import { tblPromotionItemGiftCommand } from "../../../../../../model/TblPromotion";
import { isJSON } from "../../../../../../_base/helper/FunctionHelper";
import { IconGift } from "@tabler/icons-react";

const TableItemGiftPromotion = ({
  dataPromotionItemGiftModels,
}: {
  dataPromotionItemGiftModels: tblPromotionItemGiftCommand[];
}) => {
  const headerRef = React.useRef<HTMLDivElement>(null);
  const [height, setHeight] = useState(0);
  const [rowCount, setRowCount] = useState(0);
  const [pagination, setPagination] = useState({ pageIndex: 0, pageSize: 25 });
  const [keySearch, setKeySearch] = useState<string>("");
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});
  const [selectIds, setSelectIds] = useState<string[]>([]);
  const [data, setData] = useState<tblPromotionItemGiftCommand[]>([]);
  const [dataTemp, setDataTemp] = useState<tblPromotionItemGiftCommand[]>([]);
  console.log("data", data)
  const displayData = React.useMemo(() => {
    const flattened: any[] = [];
    // Tìm các sản phẩm cha (không có attribute2)
    const parents = data.filter((item) => !item.attribute2);

    parents.forEach((parent) => {
      flattened.push({
        ...parent,
        itemPrimaryCode: parent.itemPrimaryCode || parent.itemGiftCode,
        itemPrimaryName: parent.itemPrimaryName || parent.itemGiftName,
        isChild: false,
      });

      // Tìm các sản phẩm con của cha này (attribute2 === mã hàng cha)
      const parentCode = parent.itemGiftCode || parent.itemPrimaryCode;
      const children = data.filter(
        (item) => item.attribute2 === parentCode
      );

      children.forEach((child, index) => {
        flattened.push({
          ...child,
          isChild: true,
          parentCode: parentCode,
          childIndex: index,
          itemPrimaryCode: child.itemPrimaryCode || child.itemGiftCode,
          itemPrimaryName: child.itemPrimaryName || child.itemGiftName,
        });
      });
    });
    return flattened;
  }, [data]);
  // console.log("dataPromotionItemGiftModels", dataPromotionItemGiftModels)
  console.log("displayData", displayData)

  const columns = React.useMemo<MRT_ColumnDef<any>[]>(
    () => [
      {
        accessorKey: "itemPrimaryCode",
        header: "Mã hàng",
        size: 150,
        Cell: ({ row, renderedCellValue }) => (
          <Flex align="center" gap={4} pl={row.original.isChild ? 20 : 0}>
            {row.original.isChild && (
              <IconGift
                size={14}
                stroke={1.5}
                color="var(--mantine-color-blue-6)"
              />
            )}
            <Text size="11.5px" fw={row.original.isChild ? 400 : 600}>
              {renderedCellValue}
            </Text>
          </Flex>
        ),
      },
      {
        accessorKey: "itemPrimaryName",
        header: "Tên hàng",
        Cell: ({ renderedCellValue, row }) => (
          <Tooltip label={renderedCellValue as string}>
            <Text
              truncate="end"
              w={row.original.isChild ? 480 : 500}
              size="11.5px"
              fs={row.original.isChild ? "italic" : "normal"}
            >
              {renderedCellValue}
            </Text>
          </Tooltip>
        ),
      },
      {
        accessorKey: "quantityApply",
        enableGlobalFilter: false,
        header: "SL cho phép",
        size: 80,
        Cell: ({ renderedCellValue }) => renderedCellValue,
      },
      {
        accessorKey: "quantityMax",
        header: "SLượng tối đa 1 lần được mua/1 Đ.Hàng",
        enableGlobalFilter: false,
        Cell: ({ renderedCellValue }) => renderedCellValue,
      },
    ],
    [dataPromotionItemGiftModels, displayData]
  );
  const handleChangeSearch = (e: any) => {
    const value = e.target.value.toLowerCase() ?? "";
    setKeySearch(value);
    if (value) {
      const searchResult = dataTemp.filter(
        (product) =>
          product.itemGiftCode?.toLowerCase().includes(value) ||
          product.itemGiftName?.toLowerCase().includes(value)
      );
      setSelectIds([]);
      table.resetRowSelection();
      setData(searchResult);
    } else {
      setData(dataTemp);
      setSelectIds([]);
      table.resetRowSelection();
    }
  };

  useEffect(() => {
    const valuesList = Object.keys(rowSelection);
    setSelectIds(valuesList);
    if (valuesList.length < 1) setSelectIds([]);
    else {
      const valuesList = Object.keys(rowSelection);
      setSelectIds(valuesList);
    }
  }, [rowSelection]);

  useEffect(() => {
    const headerHeight = headerRef.current?.offsetHeight || 0;
    const handleResize = () => {
      setHeight(window.innerHeight - (490 + headerHeight));
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    setDataTemp(dataPromotionItemGiftModels);
    setData(dataPromotionItemGiftModels);
    setRowCount(dataPromotionItemGiftModels.length);
  }, [dataPromotionItemGiftModels]);

  const table = useMantineReactTable({
    columns,
    data: displayData,
    positionToolbarAlertBanner: "bottom",
    renderTopToolbarCustomActions: ({ table }) => (
      <div ref={headerRef}>
        <Flex
          gap="md"
          justify="flex-start"
          align="center"
          direction="row"
          wrap="wrap"
        >
          <Box>
            <Flex gap="md">
              <TextInput
                placeholder="Nhập từ khoá"
                value={keySearch}
                onChange={handleChangeSearch}
              />
            </Flex>
          </Box>
        </Flex>
      </div>
    ),
    renderToolbarInternalActions: ({ table }) => (
      <>
        <Flex
          gap="md"
          justify={"flex-end"}
          align="center"
          direction="row"
          wrap="wrap"
        ></Flex>
      </>
    ),
    mantineTopToolbarProps: {
      style: {
        borderBottom: "3px solid rgba(128, 128, 128, 0.5)",
        marginBottom: 5,
      },
    },
    localization: _localization,
    enableRowVirtualization: true,
    enableBatchRowSelection: true,
    enablePagination: true,
    enableRowSelection: false,
    getRowId: (row) => row?.idItemGift?.toString(),
    initialState: {
      showColumnFilters: false,
      columnPinning: {
        left: [
          "mrt-row-select",
          "apply",
          "itemGiftCode",
          "namePurchase",
          "nameManufacturer",
        ],
        right: ["allocationRate", "action"],
      },
      columnVisibility: { id: false },
      density: "xs",
      showGlobalFilter: true,
    },
    enableGlobalFilter: true,
    mantineTableContainerProps: {
      style: { maxHeight: height, minHeight: height },
    },
    enableStickyHeader: true,
    onPaginationChange: setPagination,
    rowCount,
    mantineTableBodyCellProps: ({ row }) => ({
      style: {
        fontSize: "12px",
        padding: "4px 12px",
      },
    }),
    state: {
      isLoading,
      pagination,
      showAlertBanner: isError,
    },
    mantineToolbarAlertBannerProps: false
      ? { color: "red", children: "Lỗi tải dữ liệu !" }
      : undefined,
    mantinePaginationProps: {
      showRowsPerPage: false,
      withEdges: true,
      rowsPerPageOptions: ["25"],
    },
    paginationDisplayMode: "pages",
    enableColumnPinning: false,
  });

  return <MantineReactTable table={table} />;
};

export default TableItemGiftPromotion;
